import './header.js';
import './portfolio.js';
import './base.js';
import './hero.js';
import './likes.js';
import './product-image.js';
import './testimonials.js';
import './clase.js';
//import './effects/hero-effects.js';
//import './effects/home-effects.js';